import { atom } from 'jotai';

/**
 * Parâmetros de entrada do editor de slides.
 * Preenchidos pela biblioteca antes de navegar para `/slide-editor`.
 */
export interface SlideEditorParams {
  readonly slideId?: number;
  readonly categoryId?: number;
}

export const slideEditorParamsAtom = atom<SlideEditorParams>({});
slideEditorParamsAtom.debugLabel = 'slide-editor/slideEditorParamsAtom';
